import { Injectable } from '@angular/core';
import { HttpUtil } from '@shared/util/http.util';
import { Observable } from 'rxjs';
import { ApplicationConfig } from '@config/application.config';
import { Mood } from '@data/mood/Mood';
import { map } from 'rxjs/operators';
import { ObjectUtil } from '@shared/util/object.util';
import { MoodDTO } from '@data/mood/MoodDTO';
import { DateRangeCriteriaDTO } from '@data/common/DateRangeCriteriaDTO';

@Injectable({
  providedIn: 'root'
})
export class MoodApiService {
  constructor(private readonly httpUtil: HttpUtil) {
  }

  public getTodayMood(): Observable<MoodDTO> {
    return this.httpUtil.get(`${ ApplicationConfig.apiUrl }/patients/me/moods/today`)
      .pipe(
        map((response: MoodDTO) =>
          ObjectUtil.plainToInstance(MoodDTO, response)
        )
      );
  }

  public getMoodsForRange(params: DateRangeCriteriaDTO): Observable<MoodDTO[]> {
    return this.httpUtil.get(`${ ApplicationConfig.apiUrl }/patients/me/moods`, params)
      .pipe(
        map((response: MoodDTO[]) =>
          ObjectUtil.plainToInstanceArray(MoodDTO, response)
        )
      );
  }

  public selectTodayMood(mood: Mood): Observable<void> {
    return this.httpUtil.put(`${ ApplicationConfig.apiUrl }/patients/me/moods/today`, { mood });
  }
}
